import * as ActionTypes from './actionsTypes';

export const testStatusUpdate = (testId, status, result = null, progressPercentage = null) => ({
    type: ActionTypes.TEST_STATUS_UPDATE,
    id: testId,
    status,
    result,
    progressPercentage
});
